import React from "react";
import { Aside, EditButton, useDisclosure } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../../../../../core/security/SprintAccessRight";
import { EditSoundtrackAsideContent } from "./EditVideoSoundtrackAsideContent";

export interface EditVideoSoundtrackButtonAsideProps {
    isLabeled?: boolean;
    isDisabled: boolean;
}

export const EditVideoSoundtrackButtonAside: React.FunctionComponent<EditVideoSoundtrackButtonAsideProps> = (
    props: EditVideoSoundtrackButtonAsideProps
) => {
    const { isLabeled, isDisabled } = props;

    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiReadWrite]}>
            <EditButton
                onClick={onOpen}
                isLabeled={isLabeled}
                label="Edit"
                testId="edit-soundtrack"
                disabled={isDisabled}
            />
            <Aside type="form" headerText="Edit soundtrack" isOpen={isOpen} onDismiss={onClose} isLightDismiss={true}>
                <EditSoundtrackAsideContent onClose={onClose} />
            </Aside>
        </AuthorizationWrapper>
    );
};
